/**
 * A meeting's dashboard address and its public twin. A link to /dashboard/meetings/<id> opened by someone without a
 * dashboard session (a shared link, a chat app's preview) is worth more as the public meeting page (/meeting/<id>:
 * the same meeting, video and transcript for everyone, with its own title and link preview) than as a sign-in screen,
 * so the Worker answers it with a 302 there (worker/src/dashboard.js; every other site of the network has no dashboard,
 * worker/src/city-site.js) and main.tsx does the same in the browser. The meeting page's Share buttons copy the public
 * address to begin with (components/meeting/ShareMeeting.tsx, ShareClip.tsx). Shared by the Worker and the dashboard.
 */

/** The meeting page's tabs the public page has too (dashboard.js PUBLIC_MEETING); the overview is the page itself. */
const PUBLIC_TABS = new Set(["legislation", "people", "notes", "documents"]);

/**
 * /dashboard/meetings/<id>[/<tab>] → /meeting/<id>[/<tab>], with the query (?t= the moment to play from, a clip's
 * range) kept as it was; null for any other path. A tab the public page doesn't have opens the meeting itself.
 */
export function publicMeetingPath(pathname: string, search = ""): string | null {
  const m = /^\/dashboard\/meetings\/([\w-]+)(?:\/([a-z]+))?\/?$/.exec(pathname);
  if (!m) return null;
  const tab = m[2] && PUBLIC_TABS.has(m[2]) ? `/${m[2]}` : "";
  const query = search.replace(/^\?/, "");
  return `/meeting/${m[1]}${tab}${query ? `?${query}` : ""}`;
}
